export const IDS = {
  modal: 'delete-item-modal',
  button: 'delete-item-button',
};
